import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IColor, IColorHistory } from '../models/models'

export class ColorHistoryApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/color/listHistoryById',
      requesterInfo,
    })
  }

  public async historyByID(request: number): Promise<IColorHistory[]> {
    return await this.postAsync<IColorHistory[]>(request)
  }
}
